import { createSelector } from 'reselect';

export const getSpecialsList = state => state.getIn(['specials', 'specialsList']);


